export const pdfRegexp = /(application\/pdf|pdf)/
export const pdfFormatRegexp = /\.pdf$/
export const audioRegexp = /(audio)/
export const videoRegexp = /(video)/
export const audioFormatRegexp = /\.(mp3|wav|ogg|flac|aac|wma|m4a|opus|amr|aiff|mid|midi|ac3)$/
export const videoFormatRegexp = /\.(mp4|avi|mov|mkv|wmv|flv|webm|mpeg|mpg|3gp|ogv|rm|swf|vob)$/
export const imageFormatRegexp = /\.(jpg|jpeg|png|gif|bmp|svg|webp)$/
